import { motion, useAnimate, type AnimationSequence } from 'framer-motion'
import { memo, useEffect, useState } from 'react'
import { useTranslate } from '../../../hooks/language/use-translate'
import { useListenerMessage } from '../../../hooks/subscription/use-listener-message'

export const SendQuick = memo(() => {
  const [timer, setTimer] = useState(99)
  const [scope, animate] = useAnimate()

  const { translate } = useTranslate()

  function setFinish() {
    if ('ReactNativeWebView' in window) {
      // @ts-ignore
      window.ReactNativeWebView.postMessage('finished')
    }
  }

  function handleClick() {
    const sequence: AnimationSequence = [
      [scope.current, { scale: 0.8 }, { duration: 0.1 }],
      [scope.current, { scale: 1 }, { duration: 0.1 }],
    ]

    animate(sequence)
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prevState) => {
        if (prevState > 0) {
          return prevState - 1
        }

        if (prevState <= 0) {
          clearInterval(interval)
          setFinish()
          return 0
        }

        return prevState
      })
    }, 100)

    return () => {
      clearInterval(interval)
    }
  }, [])

  useListenerMessage((data) => {
    if (data === 'reset') {
      setTimer(99)
    }
  })

  return (
    <div className="w-screen h-screen flex justify-center items-center">
      <motion.div
        ref={scope}
        onClick={handleClick}
        className="h-full w-full flex flex-col items-center justify-center bg-linear-to-b from-[#4568DC] to-[#3B4781] rounded-full"
      >
        <span className="text-white">{translate('modal-gifts-send')}</span>
        <span className="text-white text-base">{timer}</span>
      </motion.div>
    </div>
  )
})
